// extracted by mini-css-extract-plugin
export default {"header":"header_header__Myy2S","imgLogo":"header_imgLogo__b5ffC","title":"header_title__zUqhk","subtitle":"header_subtitle__ogQU-"};